import { useTranslation } from 'react-i18next'

import { type ToastTone, useToastStore } from '@/stores/toastStore'
import { cn } from '@/utils/cn'

const toneClassNames: Record<ToastTone, string> = {
  info: 'border-ice/48',
  warning: 'border-deploying/60',
  error: 'border-danger/60',
}

export function ToastViewport() {
  const { t } = useTranslation()
  const toasts = useToastStore((state) => state.toasts)
  const dismissToast = useToastStore((state) => state.dismissToast)

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-0 z-50 flex flex-col items-center gap-2 px-4 pt-safe"
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            'pointer-events-auto mt-2 flex w-full max-w-sm items-start gap-3 rounded-card border bg-panel px-3 py-2 text-sm text-ink shadow-lg',
            toneClassNames[toast.tone],
          )}
        >
          <p className="flex-1">{toast.message}</p>
          <button
            type="button"
            onClick={() => dismissToast(toast.id)}
            className="text-xs text-muted"
            aria-label={t('common.dismiss')}
          >
            ✕
          </button>
        </div>
      ))}
    </div>
  )
}
